import albumCover from './images/Xmas2024Front.png'
import rossSantaDance from './images/RossSantaDance.gif'
import ruthyCandyCane from './images/RuthyCandyCane.gif'

export const funImages: string[] = [
  rossSantaDance,
  ruthyCandyCane,
]

export const backgroundImages: string[] = [
  ...funImages,
]

export const generalBackgroundImages: string[] = [
  albumCover,
  ...funImages,
]
